import { createHeadersFormOptions } from "./fetch";
import { buildApiUrl } from "./requestJson";

/**
 * Asks the server whether the stored token is still accepted, before the admin screens render.
 *
 * Any system-administrator-only GET works as the probe. Replace with a dedicated
 * `GET admin/me` if the backend adds one: this one runs a few count queries.
 */
export const SESSION_PROBE_PATH = "admin/teams/filter-options";

export const SESSION_VALID = "valid";
export const SESSION_INVALID = "invalid";
/** Network error or a 5xx: no verdict, so the user is not logged out over a blip. */
export const SESSION_UNKNOWN = "unknown";

export const validateSession = async () => {
  try {
    const response = await fetch(buildApiUrl(SESSION_PROBE_PATH), {
      headers: createHeadersFormOptions({}),
    });
    if (response.status === 401 || response.status === 403) {
      return SESSION_INVALID;
    }
    return response.ok ? SESSION_VALID : SESSION_UNKNOWN;
  } catch (_) {
    return SESSION_UNKNOWN;
  }
};
